import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    moduleAccess: {},
    rolePermissions: {},
};
const permissionsSlice = createSlice({
    name: "permissions",
    initialState,
    reducers: {
        /**
         * Set module access for a specific module
         */
        setModuleAccess: (state, action) => {
            const { moduleKey, hasAccess } = action.payload;
            state.moduleAccess[moduleKey] = hasAccess;
        },
        /**
         * Set permissions for a specific role
         */
        setRolePermissions: (state, action) => {
            const { roleId, permissions } = action.payload;
            state.rolePermissions[roleId] = permissions;
        },
        /**
         * Clear all permissions (on logout)
         */
        clearPermissions: (state) => {
            state.moduleAccess = {};
            state.rolePermissions = {};
        },
    },
});
export const { setModuleAccess, setRolePermissions, clearPermissions, } = permissionsSlice.actions;
// Selectors
export const selectModuleAccess = (state) => state.permissions.moduleAccess;
export const selectRolePermissions = (state) => state.permissions.rolePermissions;
export const selectHasModuleAccess = (moduleKey) => (state) => state.permissions.moduleAccess[moduleKey] === true;
export default permissionsSlice.reducer;
